import {observer} from "mobx-react"
import {slsPlacementCartStore} from "../../../store"
import {ScrollTable} from "../../ui"
import {DragEvent, useRef, useState} from "react"

const SlsPlacementBatchClosingSortableTable = observer(function SlsPlacementBatchClosingSortableTable() {
    const [draggingIndex, setDraggingIndex] = useState<number | null>(null)
    const [dragOverIndex, setDragOverIndex] = useState<number | null>(null)
    const dragItem = useRef<number | null>(null)

    const handleDragStart = (e: DragEvent<HTMLTableRowElement>, index: number): void => {
        setDraggingIndex(index)
        dragItem.current = index

        e.dataTransfer.effectAllowed = 'move'
        e.dataTransfer.setData('text/plain', index.toString())

        e.currentTarget.style.opacity = '0.5'
        e.currentTarget.style.cursor = 'grabbing'
    }

    const handleDragOver = (e: DragEvent<HTMLTableRowElement>, index: number): void => {
        e.preventDefault()
        e.dataTransfer.dropEffect = 'move'

        if (dragOverIndex !== index) {
            setDragOverIndex(index)
        }
    }

    const handleDragEnter = (e: DragEvent<HTMLTableRowElement>, index: number): void => {
        e.preventDefault()
        if (dragItem.current !== index && dragOverIndex !== index) {
            setDragOverIndex(index)
            e.currentTarget.style.backgroundColor = '#f0f8ff'
            e.currentTarget.style.borderTop = '2px solid #1890ff'
        }
    }

    const handleDragLeave = (e: DragEvent<HTMLTableRowElement>): void => {
        e.currentTarget.style.backgroundColor = ''
        e.currentTarget.style.borderTop = ''
    }

    const handleDrop = (e: DragEvent<HTMLTableRowElement>, dropIndex: number): void => {
        e.preventDefault()

        e.currentTarget.style.backgroundColor = ''
        e.currentTarget.style.borderTop = ''

        if (draggingIndex !== null && draggingIndex !== dropIndex) {
            slsPlacementCartStore.sortByDrag(dropIndex, draggingIndex)
        }

        setDraggingIndex(null)
        setDragOverIndex(null)
        dragItem.current = null
    }

    const handleDragEnd = (e: DragEvent<HTMLTableRowElement>): void => {
        e.currentTarget.style.opacity = '1'
        e.currentTarget.style.cursor = 'grab'

        const rows = document.querySelectorAll('.draggable-row')
        rows.forEach(row => {
            (row as HTMLElement).style.backgroundColor = '';
            (row as HTMLElement).style.borderTop = ''
        })

        setDraggingIndex(null)
        setDragOverIndex(null)
        dragItem.current = null
    }

    const getRowStyle = (index: number): React.CSSProperties => {
        const baseStyle: React.CSSProperties = {
            cursor: 'grab',
            transition: 'all 0.3s ease',
            userSelect: 'none' as const,
        }

        if (draggingIndex === index) {
            return {
                ...baseStyle,
                opacity: 0.5,
                cursor: 'grabbing',
                transform: 'scale(0.98)',
                boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
            }
        }

        if (dragOverIndex === index && draggingIndex !== index) {
            return {
                ...baseStyle,
                backgroundColor: '#e6f7ff',
                borderTop: '2px solid #1890ff',
            }
        }

        return baseStyle
    }

    return <ScrollTable>
        <thead>
        <tr>
            <th>
                Kennung
            </th>
        </tr>
        </thead>
        <tbody>
        {slsPlacementCartStore.items.map((item, index) => (
            <tr key={item.id}
                className="draggable-row"
                data-index={index}
                draggable="true"
                onDragStart={(e) => handleDragStart(e, index)}
                onDragEnter={(e) => handleDragEnter(e, index)}
                onDragLeave={handleDragLeave}
                onDragOver={e => handleDragOver(e, index)}
                onDrop={e => handleDrop(e, index)}
                onDragEnd={handleDragEnd}

                style={getRowStyle(index)}
            >
                <td>{item.correlationId}</td>
            </tr>
        ))}
        </tbody>
    </ScrollTable>
})

export {
    SlsPlacementBatchClosingSortableTable
}
